<template>
    <div class="new-form">
        <div class="titulo-input">
            <label for="titulo" v-text="$t('titulo-do-formulario')" />
            <input
                id="titulo"
                ref="titulo"
                type="text"
                v-model="formdata.title"
                @change="canAdvance()"
                v-bind:placeholder="$t('titulo-do-formulario-placeholder')"
            />
        </div>
        <div class="descricao-input">
            <label for="descricao" v-text="$t('descricao-do-formulario')" />
            <input
                id="descricao"
                ref="descricao"
                type="text"
                v-model="formdata.descricao"
                @change="canAdvance()"
                v-bind:placeholder="$t('descricao-do-formulario-placeholder')"
            />
        </div>
        <div class="ocorrencia-input">
            <label v-text="$t('ocorrencia-do-formulario')" />
            <SelectBox
                :items="ocorrencia"
                :placeholder="formdata.ocorrencia"
                :icons="false"
                @change="canAdvance()"
            />
        </div>
        <div class="radio-buttons">
            <label class="radio-box" for="sempreque">
                Sempre que
                <input
                    type="radio"
                    id="sempreque"
                    value="sempreque"
                    v-model="formdata.picked"
                    @change="canAdvance()"
                />
                <span class="checkmark"></span>
            </label>
            <label class="radio-box" for="filtros">
                Quando passar por filtros:
                <input
                    type="radio"
                    id="filtros"
                    value="filtros"
                    v-model="formdata.picked"
                    @change="canAdvance()"
                />
                <span class="checkmark"></span>
            </label>
        </div>
    </div>
</template>

<script>
import SelectBox from '@/components/shared/form/SelectBox.vue';

export default {
    props: ['formdata'],
    components: {
        SelectBox,
    },
    data() {
        return {
            //formulario: {ocorrencia:"A qualquer momento"},
            ocorrencia: [
                'Ao Finalizar um atendimento',
                'A qualquer momento',
                'Antes de Iniciar um atendimento',
            ],
            //picked: ''
        };
    },
    methods: {
        canAdvance() {
            this.$emit('validate', { value: this.formdata });
        },
    },
    updated() {
        this.canAdvance();
    },
};
</script>

<style lang="scss" scoped>
// @import "../../../../styles.scss";

.new-form {
    > div {
        text-align: left;
        margin-bottom: 10px;
        > label {
            font-weight: 600;
        }
    }
}

.radio-buttons {
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
}
</style>
